export const costCenters = [
  {
    id: 'cc_operacional',
    organizationId: 'org_3la_labs',
    name: 'Operacional',
    description: 'Custos e despesas da operação diária',
    status: 'Ativo',
  },
  {
    id: 'cc_marketing',
    organizationId: 'org_3la_labs',
    name: 'Marketing',
    description: 'Campanhas, ads e conteúdo',
    status: 'Ativo',
  },
  {
    id: 'cc_tecnologia',
    organizationId: 'org_3la_labs',
    name: 'Tecnologia',
    description: 'Infraestrutura, software e desenvolvimento',
    status: 'Ativo',
  },
  {
    id: 'cc_admin',
    organizationId: 'org_3la_labs',
    name: 'Administrativo',
    description: 'Backoffice, contabilidade e jurídico',
    status: 'Ativo',
  },
  {
    id: 'cc_comercial',
    organizationId: 'org_3la_labs',
    name: 'Comercial',
    description: 'Vendas e relacionamento com clientes',
    status: 'Ativo',
  },
];
